import { Label } from './LabelTypes';

const INDICATOR_MAXIMUM_MESSAGE_LENGTH = 4000;

export type IllegalLabel = 'TOOLONG' | 'NOMESSAGE';

export type SubmitLabelCommand = IllegalLabel | 'SUBMIT' | 'DELETE';

export function canSubmitLabel(params: { message: string, active: boolean, category?: Label['category'] }): SubmitLabelCommand {
  const { message, active, category  } = params;
  const allowEmptyMessage = category === 'sensitivity';

  if (message.length > INDICATOR_MAXIMUM_MESSAGE_LENGTH) {
    return 'TOOLONG';
  }

  if (!(message.trim())) {
    if (!active){
      return 'DELETE';
    }
    return allowEmptyMessage? 'SUBMIT' : 'NOMESSAGE';
  }

  return 'SUBMIT';
}
